/**
 * Mascarade Noire — animations v3.
 * - Vidéo d'ambiance de l'accueil : décorative, sans son, chargée après la
 *   page, seulement si le mouvement est autorisé et hors économie de données ;
 *   en pause hors écran / onglet caché ; bouton pause de 44 px (WCAG 2.2.2).
 * - Vidéo d'ambiance aussi en tête des pages collection.
 * - Titres de section qui apparaissent au défilement.
 * - Offre « 2 achetés, le 3e offert » : badge sur les cartes concernées et
 *   rappel sur la fiche produit (liste lue depuis la collection
 *   « offre-3-pour-2 », donc toujours à jour).
 * - Fiche produit : la première photo entre en douceur.
 * N'anime que transform et opacity. Sans JavaScript, rien ne change.
 */
(function () {
  'use strict';

  function reducedMotion() {
    if (document.documentElement.getAttribute('data-mn-reduced-motion') === 'true') return true;
    try {
      var stored = localStorage.getItem('mn-reduced-motion');
      if (stored === 'true') return true;
      if (stored === 'false') return false;
    } catch (e) {}
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* ---------- Vidéo d'ambiance du hero (v3) ---------- */
  function saveData() {
    var c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (!c) return false;
    return c.saveData === true || /(^|-)2g$/.test(c.effectiveType || '');
  }

  // Vidéo décorative en boucle : chargée après la page, jamais en mouvement
  // réduit ni en économie de données, en pause hors écran, bouton pause 44 px.
  function ambientVideo(holder, container) {
    var video = null;
    var button = null;
    var userPaused = false;
    var onScreen = true;

    function pickSource() {
      var mobile = holder.getAttribute('data-src-mobile');
      if (mobile && window.matchMedia('(max-width: 749px)').matches) return mobile;
      return holder.getAttribute('data-src');
    }

    function setButton(playing) {
      if (!button) return;
      button.setAttribute('aria-pressed', playing ? 'false' : 'true');
      button.setAttribute('aria-label', playing ? "Mettre la vidéo d'ambiance en pause" : "Relancer la vidéo d'ambiance");
      button.classList.toggle('is-paused', !playing);
    }

    function canPlay() {
      return !userPaused && onScreen && !document.hidden && !reducedMotion();
    }

    function sync() {
      if (!video) return;
      if (canPlay()) {
        var p = video.play();
        if (p && p.catch) p.catch(function () { setButton(false); });
      } else {
        video.pause();
      }
    }

    function teardown() {
      if (video) {
        video.pause();
        video.removeAttribute('src');
        video.load();
        video.remove();
        video = null;
      }
      if (button) {
        button.remove();
        button = null;
      }
      holder.classList.remove('is-playing');
    }

    function build() {
      if (video || reducedMotion() || saveData()) return;
      var src = pickSource();
      if (!src) return;
      video = document.createElement('video');
      video.className = 'mn-hero-video__el';
      video.muted = true;
      video.defaultMuted = true;
      video.loop = true;
      video.playsInline = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('aria-hidden', 'true');
      video.setAttribute('tabindex', '-1');
      video.setAttribute('disablepictureinpicture', '');
      video.preload = 'auto';
      video.addEventListener('playing', function () {
        holder.classList.add('is-playing');
        setButton(true);
      });
      video.addEventListener('pause', function () { setButton(false); });
      video.addEventListener('error', teardown);
      video.src = src;
      holder.appendChild(video);

      button = document.createElement('button');
      button.type = 'button';
      button.className = 'mn-hero-video__toggle';
      button.innerHTML = '<span class="mn-hero-video__icon" aria-hidden="true"></span>';
      button.addEventListener('click', function () {
        userPaused = !video.paused ? true : false;
        sync();
        setButton(!userPaused);
      });
      container.appendChild(button);
      setButton(false);
      sync();
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        onScreen = entries[0].isIntersecting;
        sync();
      }, { threshold: 0.05 }).observe(holder);
    }
    document.addEventListener('visibilitychange', sync);

    // Bouton « Réduire les animations » du site : on coupe ou relance la vidéo.
    new MutationObserver(function () {
      if (reducedMotion()) teardown();
      else build();
    }).observe(document.documentElement, { attributes: true, attributeFilter: ['data-mn-reduced-motion'] });

    // On attend que la page soit chargée pour ne pas ralentir l'affichage.
    if (document.readyState === 'complete') build();
    else window.addEventListener('load', build, { once: true });
  }

  function makeHolder(conf) {
    var holder = document.createElement('div');
    holder.className = 'mn-hero-video';
    holder.setAttribute('data-mn-hero-video', '');
    holder.setAttribute('data-src', conf.desktop || conf.mobile);
    if (conf.mobile) holder.setAttribute('data-src-mobile', conf.mobile);
    return holder;
  }

  function setupHeroVideo() {
    var conf = (window.MascaradeConfig && window.MascaradeConfig.heroVideo) || {};
    if (!conf.desktop && !conf.mobile) return;
    var main = document.querySelector('main[data-template]');
    if (!main || main.getAttribute('data-template') !== 'index') return;
    var grid = main.querySelector('.shopify-section:first-child .hero__media-grid');
    if (!grid || grid.querySelector('[data-mn-hero-video]')) return;
    var holder = makeHolder(conf);
    grid.appendChild(holder);
    ambientVideo(holder, holder.closest('.hero__container') || grid);
  }

  /* ---------- Vidéo d'ambiance des en-têtes de collection ---------- */
  function setupCollectionVideo() {
    var cfg = window.MascaradeConfig || {};
    // Vidéo propre à la collection si elle existe, sinon la vidéo commune.
    var m = /\/collections\/([^/?#]+)/.exec(location.pathname);
    var perHandle = cfg.collectionVideos && m ? cfg.collectionVideos[decodeURIComponent(m[1])] : null;
    var conf = perHandle || cfg.collectionVideo || {};
    if (!conf.desktop && !conf.mobile) return;
    var hero = document.querySelector('.mn-collection-hero');
    if (!hero || hero.querySelector('[data-mn-hero-video]')) return;
    hero.classList.add('mn-collection-hero--video');
    var holder = makeHolder(conf);
    hero.insertBefore(holder, hero.firstChild);
    ambientVideo(holder, hero);
  }

  /* ---------- Offre « 2 achetés, le 3e offert » : badges et rappel ---------- */
  var OFFER_URL = '/collections/offre-3-pour-2';
  var offerHandles = null;

  function handleFromHref(href) {
    var m = /\/products\/([^/?#]+)/.exec(href || '');
    return m ? decodeURIComponent(m[1]) : null;
  }

  function applyOffer() {
    if (!offerHandles || !offerHandles.size) return;
    document.querySelectorAll('.product-card').forEach(function (card) {
      var link = card.querySelector('a[href*="/products/"]');
      var gallery = card.querySelector('.card-gallery');
      if (!link || !gallery || gallery.querySelector('.mn-offer-badge')) return;
      if (!offerHandles.has(handleFromHref(link.getAttribute('href')))) return;
      var badge = document.createElement('span');
      badge.className = 'mn-offer-badge';
      badge.textContent = '2 achetés, le 3e offert';
      badge.title = '2 articles achetés dans la sélection, le 3e offert';
      gallery.appendChild(badge);
    });

    var main = document.querySelector('main[data-template^="product"]');
    if (!main || main.querySelector('.mn-offer-note')) return;
    if (!offerHandles.has(handleFromHref(location.pathname))) return;
    var price = main.querySelector('product-price');
    if (!price) return;
    var anchor = price.closest('.group-block, .text-block') || price;
    var note = document.createElement('p');
    note.className = 'mn-offer-note';
    note.innerHTML =
      '<span class="mn-offer-note__tag">Offre</span> ' +
      '2 articles achetés dans la sélection, le 3e offert : la remise s’applique toute seule dans le panier. ' +
      '<a href="' + OFFER_URL + '">Voir la sélection</a>';
    anchor.insertAdjacentElement('afterend', note);
  }

  function setupOffer() {
    var KEY = 'mn-offer-3p2';
    try {
      var cached = JSON.parse(sessionStorage.getItem(KEY) || 'null');
      if (cached && Date.now() - cached.t < 10 * 60 * 1000) {
        offerHandles = new Set(cached.h);
        applyOffer();
        return;
      }
    } catch (e) {}
    fetch(OFFER_URL + '/products.json?limit=250', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (data) {
        var list = (data.products || []).map(function (p) { return p.handle; });
        offerHandles = new Set(list);
        try { sessionStorage.setItem(KEY, JSON.stringify({ t: Date.now(), h: list })); } catch (e) {}
        applyOffer();
      })
      .catch(function () {});
  }

  /* ---------- Fiche produit : entrée en douceur de la première photo ---------- */
  function setupProductMediaIntro() {
    if (reducedMotion()) return;
    var main = document.querySelector('main[data-template^="product"]');
    if (!main) return;
    var img = main.querySelector('media-gallery img, .product-media img');
    if (!img || img.dataset.mnIntro) return;
    img.dataset.mnIntro = 'true';
    img.classList.add('mn-media-intro');
  }

  /* ---------- Titres de section ---------- */
  function setupHeadingReveal() {
    if (reducedMotion() || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      });
    }, { threshold: 0.2, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('main .shopify-section:not(:first-child) h2').forEach(function (h) {
      // Déjà animé par une autre couche (cartes, sections Mascarade) : on n'empile pas.
      if (h.closest('.mn-js-reveal, .mn-reveal')) return;
      var r = h.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.9 && r.bottom > 0) return;
      // État de départ posé sans transition (pas de fondu « à l'envers » hors écran).
      h.style.transition = 'none';
      h.classList.add('mn-js-reveal', 'mn-heading-reveal');
      void h.offsetWidth;
      h.style.transition = '';
      io.observe(h);
    });
  }

  function boot() {
    setupHeroVideo();
    setupCollectionVideo();
    setupHeadingReveal();
    setupOffer();
    setupProductMediaIntro();

    // Grilles filtrées / triées / paginées : badges sur les nouvelles cartes.
    if ('MutationObserver' in window) {
      var pending = false;
      new MutationObserver(function () {
        if (pending || !offerHandles) return;
        pending = true;
        window.requestAnimationFrame(function () {
          pending = false;
          applyOffer();
        });
      }).observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
